import { useParams } from '@tanstack/react-router'

import { ServerView } from './view'
import { ScreenError, ScreenLoading } from '../../components/state'
import { t } from '../../copy'
import { T } from '../../copy/text'
import { useHost, useHostActions, useHostMetrics } from '../../app/queries'

/**
 * 机器详情。**信息密度最高的一屏，设计系统就是在这儿跑通的。**
 *
 * 屏本身只负责取数与三种状态，长什么样全在 `view.tsx`——
 * 这样这一屏的视觉可以脱开路由与网络单独测。
 */
export function ServerScreen() {
  const { hostId } = useParams({ strict: false }) as { hostId?: string }
  const id = hostId ?? ''

  const host = useHost(id)
  const metrics = useHostMetrics(id)
  const actions = useHostActions(id)

  if (host.isPending) return <ScreenLoading shape="detail" />
  if (host.error) {
    return (
      <ScreenError
        title={<T id="host.list.title" />}
        error={host.error}
        onRetry={() => void host.refetch()}
      />
    )
  }
  if (!host.data) return <ScreenError error={new Error(t('error.not_found'))} />

  return (
    <ServerView
      host={host.data}
      metrics={metrics.data?.series ?? []}
      actions={actions.data?.items ?? []}
    />
  )
}
